export const Routes = {

  Root: {path: '/'},
  DashboardOverview: {path: '/admin/dashboard'},
  Orders: {path: '/admin/orders'},
  Customers: {path: '/admin/customers'},
  Planning: {path: '/admin/planning'},
  Settings: {path: '/admin/settings'},
  Vehicles: {path: '/admin/vehicles'},
  Packages: {path: '/admin/packages'},
  Surcharges: {path: '/admin/surcharges'},
  Options: {path: '/admin/options'},
  DiscountCodes: {path: '/admin/discount'},
  BookingFields: {path: '/admin/booking-fields'},
  HtmlIntegration: {path: '/admin/html-integration'},
  // Pas de route d'abonnement : la gestion de la formule passe uniquement par SubscriptionModal
  // (ouverte depuis le menu profil, les ressources verrouillées, ou ?subscription=1 sur le dashboard).
  Signin: {path: '/auth/sign-in'},
  ForgotPassword: {path: '/auth/forgot-password'},
  ResetPassword: {path: '/auth/reset-password'},
  NotFound: {path: '/error/404'},
  Booking: {path: '/booking'},
  PaymentSuccess: {path: '/booking/success'},
  PaymentCancel: {path: '/booking/cancel'},
  BookingConfirmed: {path: '/booking/confirm'},
  BookingCanceled: {path: '/booking/canceled'},
  Signup: {path: '/subscription/signup'},
  SubscriptionSuccess: {path: '/subscription/success'},

};